import { DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { useLogoutApi } from '@liquidbudget/common';

interface Props {
  onClose: () => void;
}

export function LogoutDialog({ onClose }: Props) {
  const navigate = useNavigate();

  const { mutate } = useLogoutApi({
    onSuccess: () => navigate('/login'),
  });

  const handleLogout = () => {
    mutate(undefined);
    onClose();
  };

  return (
    <DialogContent onInteractOutside={(e) => e.preventDefault()}>
      <DialogHeader>
        <DialogTitle>Are you sure you want to log out?</DialogTitle>
      </DialogHeader>
      <DialogDescription>You'll need to log in again to access your account.</DialogDescription>
      <div className="flex justify-end gap-2 mt-2">
        <Button type="button" variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button type="button" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </DialogContent>
  );
}
